<template>
  <div>
    <AccordionCard :state="cards.hakLocationState">
      <template v-slot:header>
        {{ $t('hakLocationState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('hakLocationState') }}</div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.hakLocationState"
            :options="getEnumValues('HouseLocationState')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.hakAndZsSameRoomState">
      <template v-slot:header>
        {{ $t('hakAndZsSameRoomState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('hakAndZsSameRoomState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.hakAndZsSameRoomState"
            :options="getEnumValues('YesNo')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>

      <div class="flex-row" v-if="project.measurement.ac.hakAndZsSameRoomState === 'NO'">
        <div class="flex-column name">
          {{ $t('hakAndZsSameRoomAttachments') }}
        </div>
        <div class="flex-column select">
          <p>{{ $t('upload_addtional_images') }}</p>
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="getReportTemplateImages[20].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>
      <div class="flex-row" v-if="project.measurement.ac.hakAndZsSameRoomState === 'NO'">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.hakAndZsSameRoomAttachments"
            attachmentType="hakAndZsSameRoomAttachments"
            :deletable="true"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isHakAndZsSameRoomAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="hakAndZsSameRoomAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isHakAndZsSameRoomAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.hakAttachments">
      <template v-slot:header>
        {{ $t('hakAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('hakAttachments') }}
        </div>
        <div class="flex-column select">
          <p>{{ $t('upload_addtional_images') }}</p>
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="getReportTemplateImages[19].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.hakAttachments"
            attachmentType="hakAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isHakAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="hakAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isHakAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.hakLockedState">
      <template v-slot:header>
        {{ $t('hakLockedState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('hakLockedState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.hakLockedState"
            :options="getEnumValues('YesNo')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.hakToZsDistance">
      <template v-slot:header> {{ $t('hakToZsDistance') }}</template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('hakToZsDistance') }}
        </div>
        <div class="flex-column select">
          <InputText type="text" v-model="project.measurement.ac.hakToZsDistance" />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.fireServiceSwitchPresentState">
      <template v-slot:header>
        {{ $t('fireServiceSwitchPresentState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('fireServiceSwitchPresentState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.fireServiceSwitchPresentState"
            :options="getEnumValues('YesNo')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.hakOptionalAttachments">
      <template v-slot:header>
        {{ $t('optionalAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('optionalAttachments') }}
        </div>
        <div class="flex-column select">
          {{ $t('optional_notes_description') }}
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.hakOptionalAttachments"
            attachmentType="hakOptionalAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isHakOptionalAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="hakOptionalAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isHakOptionalAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.hakNotes">
      <template v-slot:header>
        {{ $t('optional_notes') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('optional_notes') }}
        </div>
        <div class="flex-column select">
          {{ $t('optional_notes_description') }}
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <Textarea
            v-model="project.measurement.ac.hakNotes"
            :autoResize="true"
            rows="5"
            cols="30"
          />
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AccordionCard from '@/components/AccordionCard';
import DropzoneUpload from '@/components/DropzoneUpload';
import AttachmentGallery from '@/components/AttachmentGallery';
import SelectButton from 'primevue/selectbutton';
import Textarea from 'primevue/textarea';
import InputText from 'primevue/inputtext';

export default {
  name: 'LocationAndCablePath',
  components: {
    AccordionCard,
    SelectButton,
    Textarea,
    DropzoneUpload,
    AttachmentGallery,
    InputText,
  },
  props: {
    project: { type: Object },
    cards: { type: Object },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      isHakAndZsSameRoomAttachmentsUploadComplete: false,
      isHakAttachmentsUploadComplete: false,
      isHakOptionalAttachmentsUploadComplete: false,
    };
  },
  computed: { ...mapGetters(['getEnumValues', 'getReportTemplateImages']) },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isHakAndZsSameRoomAttachmentsUploadComplete = true;
          this.isHakAttachmentsUploadComplete = true;
          this.isHakOptionalAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>
